import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ColorCode } from '../../Company.enum';
import { DisplayType, Roles } from 'src/app/utils'
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { EmployeeService } from 'src/app/services/employee.service'
import { ActivatedRoute } from '@angular/router';
import { ConfirmationDailogService } from '../../shared/confirm-dailog/confirmation-dailog.service';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'admin-coadmin',
  templateUrl: './admin-coadmin.component.html',
  styleUrls: ['./admin-coadmin.component.scss'],
})
export class AdminCoadminComponent {

  @Input() list: any[] //Employee model to be added
  newList = [];
  coadmins: any = [
    {
      id: 0,
      coadminNo: 1,
    },
  ];
  name: boolean = false;
  mobile: boolean = false;
  email: boolean = false;
  fieldErrors: any[];
  openOptionDrawer: boolean;
  displayType = DisplayType;
  adminCount: number = 0;
  Form: FormGroup;
  isLoaded: boolean = false
  selectedUsers: any[] = []
  parkCoAdmin = 8
  parkAdmin = 7
  coAdminCount: number = 0;
  isChecked = false
  submitted = false
  checkboxValue: boolean = false;
  dropdownFlag: boolean = false;
  dropdownFlag2: boolean = false;
  parkTenantId: any;
  isRoleAdmin = localStorage.getItem('isRoleAdmin');
  @Output()
  refreshData = new EventEmitter<any>();
  @Output()
  searchResult = new EventEmitter<any[]>();

  emailCheck: any[] = ['a']
  emailDisplay = '@sharma.com'
  emailDomains = JSON.parse(localStorage.getItem('companyEmailDomain'));
  selectedEmail: any[] = []
  dotDropDownDetail: any

  employeeDropdownList: any[] = []
  selectedEmailCheck: any[] = []
  selectedIds: any[] = []
  userId = localStorage.getItem('userId')
  companyAdd: any;
  isCompanyActive: string;
  isTenantExpired: string;

  parTenantId: any;
  selectedBuidling: any[] = [];
  empTypes: any = [{ name: 'All', image: '', checked: false, id: 1 }, { name: 'Verified', image: 'assets/images/company/verified_user.png', checked: false, id: 2 }, { name: 'Non-verified', image: 'assets/images/company/verified_user_pending.png', checked: false, id: 3 }];
  inviteRights: any = [{ name: 'All', checked: false, id: 1 }, { name: 'With Rights', checked: false, id: 2 }, { name: 'Without Rights', checked: false, id: 3 }, { name: 'Pending Approval', checked: false, id: 5 }];
  page = 1;
  pageSize = 50;
  totalCount = 0
  noPages = 1;
  parkId = (localStorage.getItem('parkId')) ? localStorage.getItem('parkId') : null;
  isLoadData = false;
  private skipNgOnChanges = false;
  employeeCount: number = 0;
  searchText = '';
  parkBuilding: any[] = [];


  @HostListener('click', ['$event'])
  captureClick(event) {
    this.dotDropDownDetail = undefined
    if (event.target.className !== 'drawer-container') {
      this.openOptionDrawer = false;
    }
  }

  constructor(private fb: FormBuilder,
    private employeeService: EmployeeService,
    private activateRoute: ActivatedRoute,
    private confirmService: ConfirmationDailogService,
    private rolebasedactionService: RolebasedactionService,
  ) {
    this.parTenantId = this.activateRoute.snapshot.params.id;
    this.parkTenantId = this.activateRoute.snapshot.params.id;
  }

  ngOnInit() {
    this.companyAdd = this.rolebasedactionService.checkUserRolePermissionExits('Company:Create');
    this.newList = this.list;
    console.log(this.list);
    this.filterAdminCoadmin(this.list);
    this.createform()
    this.emailCheck[0] = 'a'
    this.selectedEmail[0] = this.emailDomains[0];
    this.isCompanyActive = localStorage.getItem('isCompanyActive');
    this.isTenantExpired = localStorage.getItem('isTenantExpired');
    this.getBuildingsByParkId();
  }

  ngOnChanges() {
    if (this.skipNgOnChanges) {
      this.skipNgOnChanges = false;
      return;
    }
    this.filterAdminCoadmin(this.list);
  }

  async createform() {
    // this.Form = this.fb.group({
    //   users: this.fb.array([this.fb.group({
    //     name: ['', Validators.required],
    //     phoneNumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
    //     email: ['', [Validators.required]],
    //     // parkUserId: '69AA3BA5-D51E-465E-8447-ECAA1939739A',
    //     parkTenantId: this.parkTenantId,
    //     employeeRole: 'ParkAdmin',
    //     employeeType: 'ParkiteWhitelisted',
    //     // userId: 240
    //   })])
    // })
    // this.isLoaded = true;

    this.Form = this.fb.group({
      users: this.fb.array([])
    })
    this.isLoaded = true;
    if ((this.adminCount + this.coAdminCount) == 0 && this.isRoleAdmin) {
      this.addCoadmin()
    }

  }

  get users() {
    return this.Form.get('users') as FormArray;
  }

  /// new api to be provided
  markAsAdmin($event = undefined) {
    console.log($event);
    let payload = {}
    if ($event !== undefined) {
      payload = {
        useridList: [$event.id],
        roleId: this.parkAdmin
      }
    } else {
      payload = {
        useridList: this.selectedUsers,
        roleId: this.parkAdmin
      }
    }
    this.employeeService.markAsAdmin(payload).subscribe(res => {
      console.log(res);
      this.refreshData.emit();
    });
  }

  removeAsAdmin($event = undefined) {
    console.log($event);
    let payload = {}

    // if($event !== undefined) {
    //   payload = {
    //     useridList: [$event.id],
    //     roleId: this.parkAdmin
    //   }
    // } else {
    //   payload = {
    //     useridList: this.selectedUsers,
    //     roleId: this.parkAdmin
    //   }
    // }

    // this.employeeService.revokeAsAdmin(payload).subscribe(res=> {
    //   console.log(res);
    //   this.refreshData.emit();
    // });

    this.confirmService.confirm('Please confirm..', 'Do you really want to Remove Admin ?', 'Remove')
      .then((confirmed) => {
        console.log('User confirmed:', confirmed)
        if ($event !== undefined) {
          payload = {
            useridList: [$event.id],
            roleId: this.parkAdmin
          }
        } else {
          payload = {
            useridList: this.selectedUsers,
            roleId: this.parkAdmin
          }
        }

        this.employeeService.revokeAsAdmin(payload).subscribe(res => {
          console.log(res);
          this.refreshData.emit();
        });
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  checkSelectedUserIfAdmin() {
    let check = false, check2 = false;
    this.selectedUsers.forEach((res, i) => {
      console.log(res);
      this.list.forEach(element => {
        if (element.userId == res && element.employeeRole === Roles.ParkAdmin) {
          this.dropdownFlag = false;
          check = true;
        }
        if (element.userId == res && element.employeeRole !== Roles.ParkAdmin) {
          this.dropdownFlag2 = false;
          check2 = true;
        }
      });
      if (i == (this.selectedUsers.length - 1) && !check) {
        this.dropdownFlag = true;
      }
      if (i == (this.selectedUsers.length - 1) && !check2) {
        this.dropdownFlag2 = true;
      }
    });
  }

  getSelectedUser(event) {
    console.log(event);
    if (event.checked) {
      this.selectedUsers.push(event.id);
    } else {
      var index = this.selectedUsers.indexOf(event.id);
      this.selectedUsers.splice(index, 1);
    }
    this.isChecked = ((this.coAdminCount + this.adminCount) == this.selectedUsers.length) ? true : false
    console.log(this.selectedUsers);
    this.checkSelectedUserIfAdmin();
  }

  SaveData() {
    // console.log(this.Form.controls.users['controls']);
    // this.submitted = true
    // if(this.Form.invalid)
    //   return;

    console.log(this.users.controls[0]['value']);
    this.submitted = true
    if (this.Form.invalid)
      return;

    let payload = []
    this.selectedUsers = []
    for (let i = 0; i < this.users.length; i++) {
      if (this.users.controls[i]['value'].id) {
        console.log(i);
        this.selectedUsers.push(this.users.controls[i]['value'].id);
      } else {
        let payloadData = {
          name: this.users.controls[i]['value'].name,
          phoneNumber: '+91' + this.users.controls[i]['value'].phoneNumber,
          email: (this.emailCheck[i] == 'a') ? this.users.controls[i]['value'].email + this.selectedEmail[i] : this.users.controls[i]['value'].email,
          parkTenantId: this.parkTenantId,
          employeeRole: 'ParkAdmin',
          employeeType: 'ParkiteWhitelisted',
          createdby: this.userId
        }
        payload.push(payloadData);
      }
    }

    if (payload.length > 0) {
      this.employeeService.saveEmployees(payload).subscribe(res => {
        console.log(res);
        if (res.isValid) {
          this.refreshData.emit();
          this.Form.reset()
          this.users.controls = []
          this.submitted = false;
        }
      });
    }

    if (this.selectedUsers.length > 0) {
      this.markAsAdmin()
      this.refreshData.emit();
      this.Form.reset()
      this.users.controls = []
      this.submitted = false;
    }
  }

  enterName(field) {
    if (field == 'name') {
      this.name = !this.name;
      // if (this.fullpropertyType1.length != 0) {
      // this.name = true;
      // }
    }
    if (field == 'mobile') {
      this.mobile = !this.mobile;
      // if (this.fullpropertyType1.length != 0) {
      // this.name = true;
      // }
    }
    if (field == 'email') {
      this.email = !this.email;
      // if (this.fullpropertyType1.length != 0) {
      // this.name = true;
      // }
    }
  }
  inputModelChange(adminNumber: number, type: string) {
    // this.textToLowercase(adminNumber);
    // const formStatus = this.formValidator(adminNumber, type);
    this.fieldErrors = [];
    // if (!formStatus.valid)
    // this.fieldErrors = formStatus.errFields;
    console.log('fields errors', this.fieldErrors);
  }

  onItemChange(event, i) {
    // console.log((this.companyOfficalEmailId.controls[0]['controls']['officalEmail'].value).split('@')[1]);
    // this.emailDisplay = '@'+ (this.companyOfficalEmailId.controls[0]['controls']['officalEmail'].value).split('@')[1]
    // this.emailDisplay = '@sharma.com'
    this.emailCheck[i] = event
    // this.users.get('email').addValidators(Validators.email);
    if (event == 'b') {
      console.log(this.users.controls[0]['controls']['email']);
      this.users.controls[i]['controls']['email'].setValidators([Validators.email, Validators.required]);
    } else {
      this.users.controls[i]['controls']['email'].setValidators([Validators.required]);
    }
    this.users.controls[i]['controls']['email'].updateValueAndValidity();
  }

  addCoadmin() {
    this.emailCheck[this.users.length] = ['a']
    this.selectedEmail[this.users.length] = this.emailDomains[0]
    this.users.push(this.fb.group({
      id: [''],
      name: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?^[6789][0-9]{9}$")]],
      email: ['', [Validators.required]],
      // parkUserId: '69AA3BA5-D51E-465E-8447-ECAA1939739A',
      parkTenantId: this.parkTenantId,
      employeeRole: 'ParkAdmin',
      employeeType: 'ParkiteWhitelisted',
      // userId: 240
    }));
    const data = {
      id: 0,
      coadminNo: this.coadmins.length + 1,
    };

    this.coadmins.push(data);
  }

  removeCoadmin(id) {
    this.users.removeAt(id);
    this.coadmins.forEach((item, index) => {

      if (item.coadminNo == id) this.coadmins.splice(index, 1);
    });
  }

  searchByText(event: any) {
    console.log(event);
    console.log(this.list);

    this.adminCount = 0;
    this.coAdminCount = 0;

    this.newList = this.list;

    this.newList = this.newList.filter((item: {
      isVerified: boolean;
      isActive: boolean;
      employeeRole: Roles;
      name: any
    }) => {
      return item.name.toLowerCase().includes(event.toLowerCase());
    });
    this.newList = this.newList.filter((item: {
      isVerified: boolean;
      isActive: boolean;
      employeeRole: Roles;
      name: any
    }) => {
      if (item.employeeRole == Roles.ParkAdmin && item.isActive && item.isVerified) {
        this.adminCount++;
      } else if (item.employeeRole == Roles.ParkCoAdmin && item.isActive && item.isVerified) {
        this.coAdminCount++;
      }
      return item.name.toLowerCase().includes(event.toLowerCase());
    });
    console.log(this.newList);
    if (event == '') {
      this.newList = this.list.filter((item: {
        isVerified: boolean;
        isActive: boolean;
        employeeRole: Roles;
        name: any
      }) => {
        if (item.employeeRole == Roles.ParkAdmin && item.isActive && item.isVerified) {
          //this.adminCount++;
        } else if (item.employeeRole == Roles.ParkCoAdmin && item.isActive && item.isVerified) {
          //this.coAdminCount++;
        }
        return item.name.toLowerCase().includes(event.toLowerCase());
      });
      console.log("I am in else part of search.");
    }
    // this.searchResult.emit(this.newList);
  }

  //filter admins and coadmins from employee array
  filterAdminCoadmin(employees: any[]) {

    this.adminCount = 0;
    this.coAdminCount = 0;

    if (employees != null && employees.length > 0) {
      this.list = employees.filter(res => {
        if (res.employeeRole == Roles.ParkAdmin && res.isActive && res.isVerified) {
          this.adminCount++;
        } else if (res.employeeRole == Roles.ParkCoAdmin && res.isActive && res.isVerified) {
          this.coAdminCount++;
        }
        if ((res.employeeRole == Roles.ParkAdmin && res.isActive && res.isVerified) || (res.employeeRole == Roles.ParkCoAdmin && res.isActive && res.isVerified)) {
          return res;
        }
      });
    }
  }

  selectDeselectUsers() {
    this.isChecked = !this.isChecked
    this.checkboxValue = this.isChecked
    this.selectedUsers = [];
    if (this.isChecked) {
      this.list.filter(res => {
        if (res.isRegistered) {
          this.selectedUsers.push(res.userId);
        }
      });
    }
    console.log(this.selectedUsers);
    this.checkSelectedUserIfAdmin();
  }

  clearBoxes() {
    for (let i = this.users.length; i >= 0; i--) {
      this.users.removeAt(i)
    };
  }

  selectedEmailDomain(i, value) {
    console.log(value)
    console.log(i)
    this.selectedEmail[i] = value
    console.log(this.selectedEmail)
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  getEmployeeListOnKeyDown(term, p) {
    let body = {
      parkTenantId: this.parkTenantId,
      searchTerm: term,
      employeeType: 'admin'
    }
    this.employeeService.getEmployeeListBasedonTenant(body).subscribe(res => {
      console.log(res);
      if (res.isValid) {
        if (res.list.length > 0) {
          this.openPopoverOnResponse(p)
        } else {
          p.close();
        }
        this.employeeDropdownList = res.list
      }
    });
  }

  openPopoverOnResponse(popover) {
    popover.open();
  }

  selectEmp(item, i) {
    console.log(item);
    if (item.employeeType == 'External') {
      this.emailCheck[i] = 'b'
      this.users.controls[i]['controls']['email'].setValue(item.emailId);
    } else {
      this.emailCheck[i] = 'a'
      this.getSelectedEmail(item, i);
    }
    this.users.controls[i]['controls']['name'].setValue(item.empName);
    let phone = ((item.mobileNumber.split('+91')).length > 1) ? item.mobileNumber.split('+91')[1] : item.mobileNumber
    this.users.controls[i]['controls']['phoneNumber'].setValue(phone);
    this.users.controls[i]['controls']['id'].setValue(item.userId);
    // empName
    // mobileNumber
    // emailId
  }

  getSelectedEmail(item, i) {
    let splitDomain = '@' + item.emailId.split('@')[1]
    this.selectedEmailCheck[i] = splitDomain
    console.log(this.emailDomains);
    this.users.controls[i]['controls']['email'].setValue(item.emailId.split('@')[0]);
    // this.emailDomains.forEach(element => {

    // });
  }
  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  handlePageChange(event) {
    this.page = event;
    this.getEmployeeByFilter()
  }

  closeAllTabs() {
    this.openOptionDrawer = false;
    this.dotDropDownDetail = undefined
  }

  getEmployeeByFilter() {
    this.closeAllTabs();
    let payload = {
      "parkTenantId": this.parTenantId,//"B8657E8D-C137-46A4-9DE0-BDBB01B8FC04",
      "buildingName": this.selectedBuidling,
      "verified": (this.empTypes[1].checked) ? false : true,
      "nonverified": (this.empTypes[2].checked) ? false : true,
      "withRights": (this.inviteRights[1].checked) ? false : true,
      "withOutrights": (this.inviteRights[2].checked) ? false : true,
      "pendingApproval": (this.inviteRights[3].checked) ? false : true,
      // "deactive": this.deactive,
      // "block": this.block,
      "pageNo": this.page,
      "size": this.pageSize,
      "deactive": false,
      "searchTerm": this.searchText,
      "parkId": this.parkId,
      "actionUserCategory": "AdminCoAdmin"
    }
    this.employeeService.getEmployeeListByFilter(payload).subscribe(res => {
      if (res.isValid) {
        console.log(res.data.employees);
        this.totalCount = res.data.count;
        this.adminCount = res.data.count;
        this.coAdminCount = res.data.coAdminCount;
        this.noPages = Math.ceil(this.totalCount / this.pageSize);
        this.filterActiveEmployee(res.data.employees);
        this.list = res.data.employees;
        this.newList = res.data.employees;
        this.isLoadData = true;
        this.skipNgOnChanges = true;
        this.searchResult.emit(res.data.employees);
      } else {
        this.isLoadData = true
      }
    });
  }

  filterActiveEmployee(employees: any[]) {
    employees.filter(res => {
      if (res.isActive && res.employeeRole !== Roles.ParkAdmin) {
        this.employeeCount++;
      }
    });
  }

  getBuildingsByParkId() {
    this.employeeService.getBuildingByParkIdAndTenatID(this.parkId, this.parkTenantId).subscribe(res => {
      this.selectedBuidling = res.list.map((item: any) => item.parkBuildingName);
    });
  }
}
